import { render, staticRenderFns } from "./businessGuideType.vue?vue&type=template&id=21abe1bd&scoped=true&"
import script from "./businessGuideType.vue?vue&type=script&lang=js&"
export * from "./businessGuideType.vue?vue&type=script&lang=js&"
import style0 from "./businessGuideType.vue?vue&type=style&index=0&id=21abe1bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abe1bd",
  null
  
)

export default component.exports